import { FC } from 'react';
import useGetShadowAdminReasons from '../../../../api/queries/useGetShadowAdminReasons';
import { Popup } from '@silverfort/sf-components';
import ShadowAdminReasonsContent from './ShadowAdminReasonsContent';
import ShadowAdminFooter from './ShadowAdminFooter';
import { PopupProps } from '../ExplainabilityProps';

const ShadowAdminExplainabilityPopup: FC<PopupProps> = ({ popupTitle, guid, isOpen, onClose }) => {
    const { isFetching, data } = useGetShadowAdminReasons(guid, isOpen);

    return (
        <Popup
            className="z-[11000]"
            open={isOpen}
            title={popupTitle}
            ContentComponent={ShadowAdminReasonsContent}
            ContentComponentProps={{
                loading: isFetching,
                reasons: data?.reasons,
                reasonsStr: data?.reasonsStr
            }}
            FooterComponent={ShadowAdminFooter}
            FooterComponentProps={{
                onClose
            }}
            onClose={onClose}
            popupClassName="w-[680px] h-[612px] max-w-full font-sf"
            contentClassName="relative w-full h-full"
        />
    );
};

export default ShadowAdminExplainabilityPopup;
